import { withStyles } from '@material-ui/core/styles';
import { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { BCP_47_REGEX } from './utils/constants';
import { sanitiseText } from './utils/utils';
import { globalStyles as styles } from './style/gstheme';
import PropTypes from 'prop-types';

class CustomLanguage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      languageCode: "",
      languageCodeError: false
    };
  }

  handleLanguageCodeChange = event => {
    const t = event.target;
    const cleanText = sanitiseText(t.value.trimLeft()).toLowerCase();
    const re = new RegExp(BCP_47_REGEX);
    const isValidCode = cleanText.length === 0 || (cleanText.length >= 3 && cleanText !== "und" && re.test(cleanText));
    this.setState({
      languageCode: cleanText,
      lang: cleanText,
      languageCodeError: !isValidCode
    });
    this.props.onCodeChange(cleanText, isValidCode);
  };

  render() {

    const { classes } = this.props;
    const { languageCode, languageCodeError } = this.state;

    return (
      <div>
        <TextField
          value={languageCode}
          autoFocus={true}
          style={{ marginTop: '0px' }}
          variant="outlined"
          margin="dense"
          onChange={this.handleLanguageCodeChange}
          error={languageCodeError}
          placeholder="Enter a compliant BCP-47 code"
          fullWidth
          helperText={languageCodeError ?
            languageCode === "und" ?
              <span id="invalid-code-error" data-test="helper-text">Und is reserved. Use 'No language' option.</span>
              :
              <span id="invalid-code-error" data-test="helper-text">Not a valid BCP-47 code</span>
            :
            ""}
          InputProps={{
            className: classes.inputLabel,
            inputProps: {
              "data-test": "language-code",
              "aria-label": "Language code",
              ...(languageCodeError) && {
                "aria-invalid": true,
                "aria-describedby": "invalid-code-error",
              },
              maxLength: 50
            }
          }}
        />
      </div>
    );
  }
}

CustomLanguage.defaultProps = {
};

CustomLanguage.propTypes = {
  onCodeChange: PropTypes.func.isRequired
};

export default withStyles(styles)(CustomLanguage);